// Decimal input validation utility
// This helps restrict the number of digits before and after decimal point

/**
 * Validates and formats decimal input - allows unlimited digits
 * @param {string} value - The input value
 * @returns {string} - Formatted value or empty string if invalid
 */
export const validateDecimalInput = (value) => {
  // Remove any non-numeric characters except decimal point
  let cleaned = value.replace(/[^\d.]/g, '');
  
  // Ensure only one decimal point
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    parts.splice(2); // Remove extra decimal points
    cleaned = parts.join('.');
  }
  
  // Check if it's a valid number
  if (cleaned === '' || cleaned === '.') {
    return '';
  }
  
  return cleaned;
};

/**
 * Formats a number for display with proper decimal places
 * @param {number|string} value - The value to format
 * @param {number} decimalPlaces - Number of decimal places (default: 2)
 * @returns {string} - Formatted number
 */
export const formatDecimal = (value, decimalPlaces = 2) => {
  if (!value || isNaN(value)) return '';
  
  const num = parseFloat(value);
  return num.toFixed(decimalPlaces);
};

/**
 * Handles input change with decimal validation - allows unlimited digits
 * @param {Event} e - Input change event
 * @param {Function} setValue - State setter function
 */
export const handleDecimalChange = (e, setValue) => {
  const { value } = e.target;
  const validated = validateDecimalInput(value);
  setValue(validated);
};

// Common validation presets - UNLIMITED DIGITS
export const DECIMAL_PRESETS = {
  // All fields now allow unlimited digits before and after decimal
  AMOUNT: { maxBeforeDecimal: 999, maxAfterDecimal: 999 },
  RATE: { maxBeforeDecimal: 999, maxAfterDecimal: 999 },
  HOURS: { maxBeforeDecimal: 999, maxAfterDecimal: 999 },
  PERCENTAGE: { maxBeforeDecimal: 999, maxAfterDecimal: 999 },
  QUANTITY: { maxBeforeDecimal: 999, maxAfterDecimal: 999 },
  SERVICE_TIME: { maxBeforeDecimal: 999, maxAfterDecimal: 999 }
};
